import { t } from 'i18next'
import Pagination from 'pages/Pagination'
import React, { useEffect, useState } from 'react'
import { apiGet } from 'utils/apiFetch'
import apiPath from 'utils/apiPath'
import AuctionStatusTable from './AuctionStatusTable'
import { useLocation, useNavigate } from 'react-router'
import { BiArrowBack } from 'react-icons/bi'
import helper from 'utils/helpers'

function AuctionStatus () {
  const navigate = useNavigate()
  const location = useLocation()
  const [item] = useState(location?.state?.item)
  const [auctionStatus] = useState(location?.state?.status)
  const [auctionProperty, setAuctionProperty] = useState([])
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [page, setPage] = useState(1)

  const [sort, setSort] = useState({
    sortKey: 'createdAt',
    sortType: 'desc'
  })

  const [pageSize] = useState(10)
  const getBiddingFees = async () => {
    try {
      const payload = {
        page,
        pageSize,
        // startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        // endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
        propertyId: item?._id
      }
      const path = `${apiPath.getAuctions}/bids`
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setAuctionProperty(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }
  useEffect(() => {
    getBiddingFees()
  }, [page, sort])

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  return (
    <>
      <div className='p-10 py-2 pt-4'>
        <div className='flex mb-4 pb-3 border-b-2'>
          <span
            className='flex  items-center cursor-pointer'
            onClick={() => {
              navigate(-1)
            }}
          >
            <BiArrowBack className='h-8 w-8 border text-white py-1 rounded-md bg-[#6236FF] cursor-pointer' />

            <span className='mb-2 ml-2'>
              {auctionStatus + ' ' + t('AUCTION')}
            </span>
          </span>
        </div>
      </div>
      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3 justify-between'>
              {/* <div className='col-span-2 flex flex-wrap  items-center'>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap'>
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                  />

                  <div className='flex items-center  ml-3 mb-3'>
                    <select
                      id='filterType'
                      name='filterType'
                      className='block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                      placeholder=' '
                      value={filterType}
                      onChange={handleChange}
                    >
                      <option selected value=''>
                        {t('O_ALL')}
                      </option>
                      <option value='active'>{t('O_ACTIVE')}</option>
                      <option value='inactive'>{t('O_INACTIVE')}</option>
                    </select>
                  </div>
                  <button
                    type='button'
                    onClick={handleReset}
                    className='bg-[#8FC150] text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2'
                  >
                    {t('O_RESET')}
                  </button>
                </div>
              </div> */}
              <div className='col-span-1'>
                <div>
                  <div>
                    <span className='font-semibold'>
                      {t('START_DATE_AND_TIME') + ': '}
                    </span>
                    {helper.dateFormat(item?.auctionStartDateTime)}
                  </div>
                  <div>
                    <span className='font-semibold'>
                      {t('END_DATE_AND_TIME') + ': '}
                    </span>
                    {helper.dateFormat(item?.auctionEndDateTime)}
                  </div>
                </div>
              </div>
            </form>
            <AuctionStatusTable
              sort={sort}
              auctionProperty={auctionProperty}
              setSort={setSort}
              page={page}
              getBiddingFees={getBiddingFees}
              paginationObj={paginationObj}
            />
          </div>
        </div>
        {paginationObj?.totalItems !== 0 && (
          <Pagination
            handlePageClick={handlePageClick}
            options={paginationObj}
            page={page}
          />
        )}
      </div>
    </>
  )
}

export default AuctionStatus
